<template>
  <div class="h-full overflow-y-auto" v-loading="tableLoading">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="作者姓名"
        class="!w-200px mb-10px mr-10px"
        v-model="search.authorName"
        v-if="type !== '0'"
      />
      <el-select
        size="small"
        v-model="search.departmentId"
        placeholder="部门"
        class="mr-10px mb-10px"
        clearable
        filterable
        v-if="['0', '2'].includes(type)"
      >
        <el-option
          v-for="item in orgList"
          :key="item.id"
          :label="item.displayName"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        clearable
        placeholder="发布人"
        class="!w-200px mb-10px mr-10px"
        v-model="search.pushUserName"
        v-if="type !== '2'"
      />
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>
    <el-table height="calc(100% - 110px)" class="mt-10px" border stripe :data="tableData">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column label="标题名称" prop="title" show-overflow-tooltip></el-table-column>
      <el-table-column label="发布栏目" prop="columnName" show-overflow-tooltip></el-table-column>
      <el-table-column label="发布人" prop="pushUserName" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="文字作者"
        prop="textAuthorStr"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="图片作者"
        prop="imageAuthorStr"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="视频作者"
        prop="videoAuthorStr"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="部门" prop="departmentNames" show-overflow-tooltip></el-table-column>
      <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
      <el-table-column label="发布时间" prop="pushTime" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-pagination
      class="text-right mt-20px"
      background
      @size-change="findList"
      @current-change="findList"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </div>
</template>

<script>
import { OrganizationApi } from '@wiz-api/abp-identity'
import { ManuscriptStatisticsApi } from '@wiz-api/workbench'

const organizationApi = new OrganizationApi()
const manuscriptStatisticsApi = new ManuscriptStatisticsApi()
export default {
  props: {
    type: {
      type: String,
      default: '0',
    },
    rowData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableLoading: false,
      search: {
        authorName: '',
        pushUserName: '',
        departmentId: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      orgList: [],
      tableData: [],
    }
  },
  methods: {
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.orgList = res?.items[0].children
      }
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.tableLoading = true
      const params = {
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        maxResultCount: this.page.pageSize,
        ...this.search,
      }
      switch (this.type) {
        case '0':
          params.authorName = this.rowData.authorName
          break
        case '1':
          params.departmentId = this.rowData.departmentId
          break
        case '2':
          params.pushUserId = this.rowData.pushUserId
          break
        default:
          params.columnId = this.rowData.id
          break
      }
      const [err, res] = await manuscriptStatisticsApi.getView(params)
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
    },
  },
  created() {
    this.getOrgData()
  },
}
</script>

<style></style>
